import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import AOS from "aos";
import { Helmet, HelmetProvider } from "react-helmet-async";
import {
  Row,
  Col,
  Form,
  Button,
  Container,
  Alert,
  Card,
  Modal,
} from "react-bootstrap";
import {
  FaUserCheck,
  FaBriefcase,
  FaGraduationCap,
  FaLaptopCode,
} from "react-icons/fa";
import { Accordion } from "react-bootstrap";
import Footer from "../Footer/Footer";
import {
  BriefcaseFill,
  PeopleFill,
  CpuFill,
  LightbulbFill,
} from "react-bootstrap-icons";
import data from "../../Meta/Meta_ApiUrl";
import "../../assest/css/Internship.css";
import img2 from "../../assest/image/Internship/Who Can Apply.jpg";
import axios from "axios";
import Apiurl from "../environments/Apiurl";

const Internship = () => {
  const [meta, setMeta] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    collegeName: "",
    degree: "",
    department: "",
    currentYear: "",
    doj: "",
    course: "",
    learningMode: "",
  });
  const [errors, setErrors] = useState({});
  const [submitMessage, setSubmitMessage] = useState("");
  const [submitError, setSubmitError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();

  const courses1 = [
    { id: 1, title: "Python Full Stack Development" },
    { id: 2, title: "Java Full Stack Development" },
    { id: 3, title: "MERN Stack Development" },
    { id: 4, title: "MEAN Stack Development" },
    { id: 5, title: "Mobile App Development" },
    { id: 6, title: "Data Analysis" },
    { id: 7, title: "UI/UX Design" },
    { id: 8, title: "AWS Cloud" },
    { id: 9, title: "DevOps Engineering" },
  ];

  const years = [
    { id: 1, label: "1st Year" },
    { id: 2, label: "2nd Year" },
    { id: 3, label: "3rd Year" },
    { id: 4, label: "4th Year" },
  ];

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-out-cubic",
      once: true,
      offset: 50,
    });

    const InternshipMeta = data && data[0]?.internship_page;
    if (InternshipMeta) {
      setMeta(InternshipMeta);
    }
  }, []);

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim())
      newErrors.name = "Name is required";
    
    if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))
      newErrors.email = "Valid email is required";
    
    // Mobile number validation - exactly 10 digits
    if (!formData.mobile) {
      newErrors.mobile = "Mobile number is required";
    } else if (formData.mobile.length !== 10) {
      newErrors.mobile = "Mobile number must be exactly 10 digits";
    } else if (!/^\d+$/.test(formData.mobile)) {
      newErrors.mobile = "Mobile number must contain only digits";
    }
  
    if (!formData.collegeName.trim())
      newErrors.collegeName = "College name is required";
    
    if (!formData.degree.trim())
      newErrors.degree = "Degree is required";
    
    if (!formData.department.trim())
      newErrors.department = "Department is required";
    
    if (!formData.currentYear)
      newErrors.currentYear = "Please select current year";
    
    if (!formData.course) 
      newErrors.course = "Please select a course";
    
    if (!formData.learningMode)
      newErrors.learningMode = "Please select a learning mode";
    
    return newErrors;
  };

  const handleInputChange = (name, value) => {
    // Special handling for mobile - only allow numbers and max 10 digits
    if (name === "mobile") {
      value = value.replace(/\D/g, '').slice(0, 10);
    }
    
    setFormData({ ...formData, [name]: value });
    if (errors[name]) {
      setErrors({ ...errors, [name]: null });
    }
    if (submitError) setSubmitError("");
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setSubmitError("");
      setSubmitMessage("");
      return;
    }

    setIsSubmitting(true);
    setSubmitError("");
    setSubmitMessage("");

    try {
      const payload = {
        name: formData.name.trim(),
        email: formData.email.trim(),
        phone_number: formData.mobile.trim(),
        college_name: formData.collegeName.trim(),
        degree: formData.degree.trim(),
        department: formData.department.trim(),
        current_year: formData.currentYear,
        date_of_joining: formData.doj,
        internship_field: formData.course,
        preferred_mode: formData.learningMode.toLowerCase(),
      };

      console.log("✅ Submitting:", payload);
      const response = await axios.post(`${Apiurl}/internship-enquiries`, payload);
      console.log("✅ Submitted:", response.data);
      
      setSubmitMessage("Registration successful! We'll contact you soon.");
      setFormData({
        name: "",
        mobile: "",
        email: "",
        collegeName: "",
        degree: "",
        department: "",
        currentYear: "",
        doj: "",
        course: "",
        learningMode: "",
      });
      setErrors({});
      
      // Close modal if it's open after 2 seconds
      if (showModal) {
        setTimeout(() => {
          setShowModal(false);
          setSubmitMessage("");
        }, 2000);
      }
    } catch (err) {
      console.error("❌ Error:", err);
      setSubmitError(err.response?.data?.message || "Failed to register. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleApplyNowClick = () => {
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setFormData({
      name: "",
      mobile: "",
      email: "",
      collegeName: "",
      degree: "",
      department: "",
      currentYear: "",
      doj: "",
      course: "",
      learningMode: "",
    });
    setErrors({});
    setSubmitMessage("");
    setSubmitError("");
  };

  return (
    <HelmetProvider>
      <div className="container-fluid p-0 overflow-x-hidden overflow-y-auto internship-container">
        <Helmet>
          <title>{meta?.title || "Internship - Aalan Techsoft"}</title>
          <meta
            name="description"
            content={
              meta?.meta?.meta1?.content ||
              "Our mission is to empower innovators to visually create, build, and automate to their true potential."
            }
          />
        </Helmet>

        {/* Modal for Registration Form */}
        <Modal show={showModal} onHide={handleModalClose} centered size="md">
          <Modal.Header closeButton>
            <Modal.Title>Registration Form</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {submitMessage && <Alert variant="success">{submitMessage}</Alert>}
            {submitError && <Alert variant="danger">{submitError}</Alert>}
            <Form onSubmit={handleFormSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Name *</Form.Label>
                <Form.Control
                  type="text"
                  className="bg-white"
                  name="name"
                  value={formData.name}
                  onChange={(e) => handleInputChange("name", e.target.value)}
                  isInvalid={!!errors.name}
                  placeholder="Enter your full name"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Email *</Form.Label>
                <Form.Control
                  type="email"
                  className="bg-white"
                  name="email"
                  value={formData.email}
                  onChange={(e) => handleInputChange("email", e.target.value)}
                  isInvalid={!!errors.email}
                  placeholder="Enter your email"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Mobile Number *</Form.Label>
                <Form.Control
                  type="tel"
                  className="bg-white"
                  name="mobile"
                  value={formData.mobile}
                  onChange={(e) => handleInputChange("mobile", e.target.value)}
                  onKeyPress={(e) => {
                    // Allow only numbers
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  isInvalid={!!errors.mobile}
                  placeholder="Enter 10-digit mobile number"
                  maxLength={10}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errors.mobile}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>College Name *</Form.Label>
                <Form.Control
                  type="text"
                  className="bg-white"
                  name="collegeName"
                  value={formData.collegeName}
                  onChange={(e) => handleInputChange("collegeName", e.target.value)}
                  isInvalid={!!errors.collegeName}
                  placeholder="Enter college name"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errors.collegeName}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Degree *</Form.Label>
                <Form.Control
                  type="text"
                  className="bg-white"
                  name="degree"
                  value={formData.degree}
                  onChange={(e) => handleInputChange("degree", e.target.value)}
                  isInvalid={!!errors.degree}
                  placeholder="Enter your degree (e.g., B.Tech, B.E)"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errors.degree}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Department *</Form.Label>
                <Form.Control
                  type="text"
                  className="bg-white"
                  name="department"
                  value={formData.department}
                  onChange={(e) => handleInputChange("department", e.target.value)}
                  isInvalid={!!errors.department}
                  placeholder="Enter your department"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errors.department}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Current Year *</Form.Label>
                <Form.Select
                  name="currentYear"
                  value={formData.currentYear}
                  onChange={(e) => handleInputChange("currentYear", e.target.value)}
                  isInvalid={!!errors.currentYear}
                  required
                >
                  <option value="">Select current year</option>
                  {years.map((year) => (
                    <option key={year.id} value={year.label}>
                      {year.label}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.currentYear}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Interested Internship *</Form.Label>
                <Form.Select
                  name="course"
                  value={formData.course}
                  onChange={(e) => handleInputChange("course", e.target.value)}
                  isInvalid={!!errors.course}
                  required
                >
                  <option value="">Select a course</option>
                  {courses1.map((course) => (
                    <option key={course.id} value={course.title}>
                      {course.title}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.course}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Date of Joining</Form.Label>
                <Form.Control
                  type="date"
                  className="bg-white"
                  name="doj"
                  value={formData.doj}
                  onChange={(e) => handleInputChange("doj", e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Preferred Mode of Learning *</Form.Label>
                <Form.Select
                  name="learningMode"
                  value={formData.learningMode}
                  onChange={(e) => handleInputChange("learningMode", e.target.value)}
                  isInvalid={!!errors.learningMode}
                  required
                >
                  <option value="">Choose a mode</option>
                  <option value="online">Online</option>
                  <option value="offline">Offline</option>
                  <option value="hybrid">Hybrid</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.learningMode}
                </Form.Control.Feedback>
              </Form.Group>

              <div className="text-center">
                <Button
                  variant="primary"
                  type="submit"
                  style={{
                    backgroundColor: "rgb(133, 191, 57)",
                    border: "none",
                  }}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>

        {/* Hero Section */}
        <div className="internship-hero d-flex align-items-center justify-content-center text-center">
          <div className="internship-content">
            <div className="hero-title-container" data-aos="fade-up">
              <span className="badge-title">Internship</span>
              <br />
              <h1 className="text-white fw-bold">
                Launch Your Tech Career with ATS Internships
              </h1>
            </div>
          </div>
        </div>

        {/* Who Can Apply Section */}
        <section>
          <div className="container py-5 ">
            <div
              className="row align-items-center gx-5"
              style={{ margin: "30px 0" }}
            >
              <div className="col-12 col-md-12 col-lg-6 mb-4 mb-md-4" data-aos="fade-up">
                <h2
                  className="section-title fw-bold display-5 mb-3"
                  data-aos="fade-right"
                  data-aos-delay="100"
                >
                  <span className="badge-title">Who Can Apply</span>
                </h2>

                <h2 className="fw-semibold mb-3">Are You a Good Fit?</h2>
                <p className="section-text mb-4" style={{ textAlign: "justify" }}>
                  We welcome college students and freshers passionate about
                  technology, coding, and software development. No prior
                  experience? No problem. A willingness to learn and a
                  problem solving mindset are all you need!
                </p>
                <Button
                  className="custom-btn mt-3 mt-sm-4 mt-md-5 shadow-sm px-4 py-2"
                  onClick={handleApplyNowClick}
                >
                  <span className="btn-text fw-semibold">Apply Now</span>
                </Button>
              </div>

              <div
                className="col-12 col-md-12 col-lg-6 text-center"
                data-aos="fade-right"
              >
                <img
                  src={img2}
                  alt="College students eligible to apply"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: "400px", width: "100%" }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose Section */}
        <section className="features-section py-5 bg-light">
          <Container>
            <div className="text-center mb-5">
              <h2
                className="fw-bold section-title"
                data-aos="fade-down"
                data-aos-duration="1000"
                data-aos-delay="100"
              >
                Why Choose <span style={{ color: "#85bf39" }}>Our Internship Program?</span>
              </h2>
              <p
                className="mb-0 section-text text-center"
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-delay="100"
              >
                At ATS, we believe in nurturing talent by offering immersive learning
                experiences.
              </p>
            </div>

            <Row className="g-4">
              <Col xs={12} sm={6} lg={3} data-aos="zoom-in" data-aos-delay="100" data-aos-duration="1000">
                <div className="feature-card bg-white rounded-4 shadow p-4 text-center h-100 position-relative">
                  <div
                    className="icon-wrapper bg-light mb-3 mx-auto rounded-3 d-flex justify-content-center align-items-center"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <BriefcaseFill size={40} style={{ color: "#85bf39" }} />
                  </div>
                  <h5 className="fw-bold mb-2 card-title">Hands-on Projects</h5>
                  <p className="mb-0 card-text">
                    Work on real-world projects aligned with industry needs.
                  </p>
                </div>
              </Col>

              <Col xs={12} sm={6} lg={3} data-aos="zoom-in" data-aos-delay="100" data-aos-duration="1000">
                <div className="feature-card bg-white rounded-4 shadow p-4 text-center h-100 position-relative">
                  <div
                    className="icon-wrapper bg-light mb-3 mx-auto rounded-3 d-flex justify-content-center align-items-center"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <PeopleFill size={40} style={{ color: "#85bf39" }} />
                  </div>
                  <h5 className="fw-bold mb-2 card-title">Mentorship</h5>
                  <p className="mb-0 card-text">
                    Guidance from seasoned professionals throughout your journey.
                  </p>
                </div>
              </Col>

              <Col xs={12} sm={6} lg={3} data-aos="zoom-in" data-aos-delay="100" data-aos-duration="1000">
                <div className="feature-card bg-white rounded-4 shadow p-4 text-center h-100 position-relative">
                  <div
                    className="icon-wrapper bg-light mb-3 mx-auto rounded-3 d-flex justify-content-center align-items-center"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <CpuFill size={40} style={{ color: "#85bf39" }} />
                  </div>
                  <h5 className="fw-bold mb-2 card-title">Cutting-edge Tech</h5>
                  <p className="mb-0 card-text">
                    Get exposure to the latest tools and technologies.
                  </p>
                </div>
              </Col>

              <Col xs={12} sm={6} lg={3} data-aos="zoom-in" data-aos-delay="100" data-aos-duration="1000">
                <div className="feature-card bg-white rounded-4 shadow p-4 text-center h-100 position-relative">
                  <div
                    className="icon-wrapper bg-light mb-3 mx-auto rounded-3 d-flex justify-content-center align-items-center"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <LightbulbFill size={40} style={{ color: "#85bf39" }} />
                  </div>
                  <h5 className="fw-bold mb-2 card-title">Collaborative Culture</h5>
                  <p className="mb-0 card-text">
                    An open, supportive environment where ideas flourish.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Contact Form Section */}
        <section className="contact-section py-5 mt-3 mb-2">
          <Container>
            {submitMessage && <Alert variant="success" className="mb-4">{submitMessage}</Alert>}
            {submitError && <Alert variant="danger" className="mb-4">{submitError}</Alert>}
            <Row className="align-items-stretch g-4">
              <Col
                xs={12}
                lg={7}
                className="text-start d-flex flex-column"
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                <h2 className="section-title mb-3">
                  Kickstart Your Software <br />Internship Today!
                </h2>
                <p className="section-text mb-4" style={{ textAlign: "justify" }}>
                  Welcome to Aalan Tech soft! As a college student eager to dive into the world of software development, our internship program is your gateway to real world experience. Apply now and transform your academic skills into professional expertise!
                </p>

                <ul className="icon-list d-none d-lg-block">
                  <li
                    className="d-flex align-items-center mb-3"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <div className="icon-box">
                      <FaUserCheck />
                    </div>
                    <span className="section-text fw-semibold">
                      Dedicated Mentors & Industry Guidance
                    </span>
                  </li>
                  <li
                    className="d-flex align-items-center mb-3"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <div className="icon-box">
                      <FaLaptopCode />
                    </div>
                    <span className="section-text fw-semibold">
                      Hands-on Coding Projects & Live Deployments
                    </span>
                  </li>
                  <li
                    className="d-flex align-items-center mb-3"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <div className="icon-box">
                      <FaBriefcase />
                    </div>
                    <span className="section-text fw-semibold">
                      Networking Events & Resume Building Support
                    </span>
                  </li>
                  <li
                    className="d-flex align-items-center mb-3"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <div className="icon-box">
                      <FaGraduationCap />
                    </div>
                    <span className="section-text fw-semibold">
                      Internship Certificate & Recommendation Letters
                    </span>
                  </li>
                </ul>
              </Col>

              <Col xs={12} lg={5} data-aos="fade-left" data-aos-duration="1000">
                <Card className="contact-form-card shadow-lg rounded-4 p-4 h-100">
                  <Card.Body>
                    <h3
                      className="contact-title mb-4"
                      style={{ color: "#85bf39" }}
                    >
                      Internship Registration Form
                    </h3>
                    <Form onSubmit={handleFormSubmit}>
                      <Form.Group className="mb-3">
                        <Form.Label>Name *</Form.Label>
                        <Form.Control
                          type="text"
                          className="bg-white"
                          name="name"
                          value={formData.name}
                          onChange={(e) => handleInputChange("name", e.target.value)}
                          placeholder="Enter your full name"
                          isInvalid={!!errors.name}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.name}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Email *</Form.Label>
                        <Form.Control
                          type="email"
                          className="bg-white"
                          name="email"
                          value={formData.email}
                          onChange={(e) => handleInputChange("email", e.target.value)}
                          placeholder="Enter your email"
                          isInvalid={!!errors.email}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.email}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Mobile Number *</Form.Label>
                        <Form.Control
                          type="tel"
                          className="bg-white"
                          name="mobile"
                          value={formData.mobile}
                          onChange={(e) => handleInputChange("mobile", e.target.value)}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          placeholder="Enter 10-digit mobile number"
                          isInvalid={!!errors.mobile}
                          maxLength={10}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.mobile}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>College Name *</Form.Label>
                        <Form.Control
                          type="text"
                          className="bg-white"
                          name="collegeName"
                          value={formData.collegeName}
                          onChange={(e) => handleInputChange("collegeName", e.target.value)}
                          placeholder="Enter college name"
                          isInvalid={!!errors.collegeName}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.collegeName}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Degree *</Form.Label>
                        <Form.Control
                          type="text"
                          className="bg-white"
                          name="degree"
                          value={formData.degree}
                          onChange={(e) => handleInputChange("degree", e.target.value)}
                          placeholder="Enter your degree (e.g., B.Tech, B.E)"
                          isInvalid={!!errors.degree}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.degree}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Department *</Form.Label>
                        <Form.Control
                          type="text"
                          className="bg-white"
                          name="department"
                          value={formData.department}
                          onChange={(e) => handleInputChange("department", e.target.value)}
                          placeholder="Enter your department"
                          isInvalid={!!errors.department}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.department}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Current Year *</Form.Label>
                        <Form.Select
                          name="currentYear"
                          value={formData.currentYear}
                          onChange={(e) => handleInputChange("currentYear", e.target.value)}
                          isInvalid={!!errors.currentYear}
                        >
                          <option value="">Select current year</option>
                          {years.map((year) => (
                            <option key={year.id} value={year.label}>
                              {year.label}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.currentYear}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Interested Internship *</Form.Label>
                        <Form.Select
                          name="course"
                          value={formData.course}
                          onChange={(e) => handleInputChange("course", e.target.value)}
                          isInvalid={!!errors.course}
                        >
                          <option value="">Select a course</option>
                          {courses1.map((course) => (
                            <option key={course.id} value={course.title}>
                              {course.title}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.course}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Date of Joining</Form.Label>
                        <Form.Control
                          type="date"
                          className="bg-white"
                          name="doj"
                          value={formData.doj}
                          onChange={(e) => handleInputChange("doj", e.target.value)}
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Preferred Mode of Learning *</Form.Label>
                        <Form.Select
                          name="learningMode"
                          value={formData.learningMode}
                          onChange={(e) => handleInputChange("learningMode", e.target.value)}
                          isInvalid={!!errors.learningMode}
                        >
                          <option value="">Choose a mode</option>
                          <option value="online">Online</option>
                          <option value="offline">Offline</option>
                          <option value="hybrid">Hybrid</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.learningMode}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Button
                        type="submit"
                        className="btn btn-md sendmessage w-100"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Submitting..." : "Register"}
                      </Button>
                    </Form>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

        {/* FAQ Section */}
        <section className="faq-section py-5 px-md-4">
          <div className="faq-container px-3 px-sm-4">
            <h2 className="text-center fw-bold mb-4 faq-title">
              Frequently Asked <span>Questions</span>
            </h2>
            <p className="text-center mb-5 faq-subtitle">
              Find answers to common questions about our internship program.
            </p>
            <Accordion defaultActiveKey="0" className="faq-accordion">
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  Will I have the opportunity to work on real-world projects?
                </Accordion.Header>
                <Accordion.Body className="fs-6 accordion-para">
                  Absolutely! Interns at Aalan Tech Soft will have the
                  opportunity to work on real-world projects, contributing to
                  the company's actual products or client projects.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  How can I apply for an internship at Aalan Tech Soft?
                </Accordion.Header>
                <Accordion.Body className="fs-6 accordion-para">
                  You can apply for an internship through our online application
                  portal on our 'internship' page.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  What type of internships does Aalan Tech Soft offer?
                </Accordion.Header>
                <Accordion.Body className="fs-6 accordion-para">
                  We offer a variety of software internships across multiple
                  domains, including:
                  <ul>
                    <li>
                      Web Development: Frontend and backend development, web
                      design, UI/UX design
                    </li>
                    <li>
                      Mobile App Development: iOS and Android app development
                    </li>
                    <li>
                      E-Commerce Development: Development and maintenance of
                      e-commerce platforms
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  How long are the internships at Aalan Tech Soft?
                </Accordion.Header>
                <Accordion.Body className="fs-6 accordion-para">
                  Internship durations may vary depending on the specific
                  program and project requirements. We offer both short-term and
                  long-term internships.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </section>

        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default Internship;